import React, { createContext, useContext } from 'react';
import { ISortableWidgetEditorProps } from '../ISortableWidgetEditorProps';

export interface EngineReactComponentsContext {
  sortableWidgetEditor: React.ComponentType<ISortableWidgetEditorProps>;
}

export const EngineReactComponentsContext =
  createContext<EngineReactComponentsContext>({
    sortableWidgetEditor: () => null,
  });

export function useEngineReactComponentsContext() {
  return useContext(EngineReactComponentsContext);
}
